export function buildInstructionFilesDisplaySummary(filePaths: string[]): string {
  if (filePaths.length === 1) {
    return `Instructions loaded from: ${filePaths[0]}`;
  }

  const visiblePaths = filePaths.slice(0, 3).join(', ');
  const remainingCount = filePaths.length - 3;
  const suffix = remainingCount > 0 ? `, and ${remainingCount} more` : '';
  return `Instructions loaded from ${filePaths.length} files: ${visiblePaths}${suffix}`;
}

export function isInstructionFilesDisplaySummary(
  description: string | null | undefined,
  filePaths: string[],
): boolean {
  return Boolean(
    description?.trim() &&
    filePaths.length > 0 &&
    description.trim() === buildInstructionFilesDisplaySummary(filePaths),
  );
}

export function getTextInstructionDescription(
  description: string | null | undefined,
  filePaths: string[],
): string {
  const trimmedDescription = description?.trim() ?? '';
  if (!trimmedDescription || isInstructionFilesDisplaySummary(trimmedDescription, filePaths)) {
    return '';
  }

  return trimmedDescription;
}
